module.exports = __webpack_public_path__ + "static/img/cyberspace.b59617d6.png";